
import "./GothamNarrow/style.css";
import "./HelveticaNeue/style.css";
import "./ProximaNovaLight/style.css";
import "./ProximaNovaBold/style.css";
import "./MyriadProBold/style.css";
import "./MinionProRegular/style.css";
import "./MrEavesXLModOT-BoldFont/style.css";
import "./MrEavesXLModOT-RegFont/style.css";
import './GateHouse/SangBleuKingdomBold/style.css';
import "./GateHouse/SequelSansMedium/style.css";

const RizeColors = {
    'color-ink-lightest': '#919EAB',
    'color-complete-button': '#DE5722',
    'color-teal-dark': '#DE5722',
    'button-background-color': '#DE5722',
    'color-juniper': '#DE5722',
    'toast-message-text': '#DE5722',
    'color-search-border': "#DE5722",
    'complete-button': '#DE5722',

    'color-ink-lighter': '#637381',
    'color-disabled-button': "#637381",
    'color-sky': '#DFE3E8',
    'color-teal': '#DE5722',
    'color-checkIcon': '#DE5722',
    'walkthroughcompletecheckbox': '#DE5722',
    'color-sidebar-button-text': 'white',
    'color-issue-type-header': '#DE5722',
    'color-anchor-link': '#DE5722',
    'color-ink-light': '#454F5B',
    'color-juniper-dark': '#E8E3DA',
    'tab-background-color': '#E8E3DA',
    'color-juniper-darker': '#E8E3DA',
    'color-red-darker': '#330001',
    'color-red-lighter': '#FBE9E5',
    'color-sky-dark': '#C4CDD5',
    'color-teal-darker': '#DE5722',
    'color-teal-lighter': '#E0F5F5',
    'color-yellow-lighter': '#E8E3DA',
    'color-yellow-darker': '#573A00',
    'links': '#DE5722',
    'color-dark': '#212B36',
    'breadcrumb': '#DE5722',
    'left-nav-text-color': '#756C69',
    'left-nav-active-text-color': '#de5722',
    'color-left-nav-background': '#E8E3DA',

    'time-line': '#DE5722',
    'toast-background-shadow': '#DE5722',


    'icomoon-color': '#DE5722',
    'sidebar-tenant-color': '#DE5722',
    'closed-overview-color': '#E8E3DA',
    'backGroundColors': '#DE5722',
    'recentActivityPanColor': '#E8E3DA',
    'HOtitle': '#DE5722',
    'textAreaOnFocusBroderHighLight': '#DE5722',
    'tableListHoverColor': 'transparentize(#DE5722, .9)',


    'toastSuccessColor':'#DE5722',
    'toastSuccessBackGroundColor':'#E8E3DA',
    'toastSuccessBorderColor':'#DE5722',
    'toastSuccessProgressBarColor':'#DE5722',
    'toastSuccessCloseButtonColor':'#DE5722',
    'toastErrorColor':'#5A302F',
    'toastErrorBackGroundColor':'hsl(14, 72%, 94%)',
    'toastErrorBorderColor':'#5A302F',
    'toastErrorProgressBarColor':'#5A302F',
    'toastErrorCloseButtonColor':"#5A302F",
    'color-expires-text': "#573B00",

    'primary-heading-font': "DM Serif Display,serif",
    'general-content-font': 'Assistant,sans-serif',
    'secondary-heading-font': "Assistant,sans-serif",    
}
const AlbasterColors = {
    'color-ink-lightest': '#A19A94',
    'color-complete-button': '#D2CFCF',
    'color-teal-dark': '#A19A94',
    'button-background-color': '#A19A94',
    'color-juniper': '#D2CFCF',
    'toast-message-text': '#D2CFCF',
    'color-search-border': "#D2CFCF",
    'complete-button': '#D2CFCF',
    'color-ink-lighter': '#637381',
    'color-disabled-button': "#637381",
    'color-sky': '#DFE3E8',
    'color-teal': '#D2CFCF',
    'color-checkIcon': '#D2CFCF',
    'walkthroughcompletecheckbox': '#D2CFCF',
    'color-sidebar-button-text': 'white',
    'color-issue-type-header': '#D2CFCF',
    'color-anchor-link': '#D2CFCF',

    'color-ink-light': '#454F5B',
    'color-juniper-dark': '#A19A94',
    'tab-background-color': '#A19A94',

    'color-juniper-darker': '#34312E',
    'color-red-darker': '#34312E',
    'color-red-lighter': '#F4F4F4',
    'color-sky-dark': '#C4CDD5',
    'color-teal-darker': '#34312E',
    'color-teal-lighter': '#F4F4F4',
    'color-yellow-lighter': '#F4F4F4',
    'color-yellow-darker': '#34312E',
    'links': '#A19A94',
    'color-dark': '#212B36',
    'breadcrumb': '#34312E',
    'left-nav-text-color': '#A19A94',
    'left-nav-active-text-color': 'white',
    'color-left-nav-background': '#D2CFCF',

    'time-line': '#A19A94',
    'toast-background-shadow': '#D2CFCF',

    'icomoon-color': '#34312E',
    'sidebar-tenant-color': 'white',
    'closed-overview-color': '#c4cdd5',
    'backGroundColors': '#A19A94',
    'recentActivityPanColor': '#A19A94',
    'HOtitle': '#A19A94',
    'textAreaOnFocusBroderHighLight': '#A19A94',
    'tableListHoverColor': 'transparentize(#A19A94, .9)',

    'toastSuccessColor':'#A19A94',
    'toastSuccessBackGroundColor':'#D2CFCF',
    'toastSuccessBorderColor':'#34312E',
    'toastSuccessProgressBarColor':'#34312E',
    'toastSuccessCloseButtonColor':'#34312E',


    'toastErrorColor':'#5A302F',
    'toastErrorBackGroundColor':'hsl(14, 72%, 94%)',
    'toastErrorBorderColor':'#5A302F',
    'toastErrorProgressBarColor':'#5A302F',
    'toastErrorCloseButtonColor':"#5A302F",
    'color-expires-text': "#573B00",

    'primary-heading-font': 'GT Sectra',
    'general-content-font': 'GT Sectra',
    'secondary-heading-font': "GT Sectra",
}
const JuniperColors = {
    'color-ink-lightest': '#919EAB',
    'color-complete-button': '#43467F',
    'color-teal-dark': '#00848E',
    'button-background-color': '#00848E',
    'color-juniper': '#43467F',
    'toast-message-text': '#43467F',
    'color-search-border': "#43467F",
    'complete-button': '#43467F',
    'color-ink-lighter': '#637381',
    'color-disabled-button': "#637381",
    'color-sky': '#DFE3E8',
    'color-teal': '#48C1BF',
    'color-checkIcon': '#48C1BF',
    'walkthroughcompletecheckbox': '#48C1BF',
    'color-sidebar-button-text': 'white',
    'color-issue-type-header': '#43467F',
    'color-anchor-link': '#43467F',

    'color-ink-light': '#454F5B',
    'color-juniper-dark': '#1C2260',
    'tab-background-color': '#1C2260',
    'color-juniper-darker': '#00044C',
    'color-red-darker': '#330001',
    'color-red-lighter': '#FBE9E5',
    'color-sky-dark': '#C4CDD5',
    'color-teal-darker': '#003135',
    'color-teal-lighter': '#E0F5F5',
    'color-yellow-lighter': '#FBF1CD',
    'color-yellow-darker': '#573A00',
    'links': '#54938B',
    'color-dark': '#212B36',
    'breadcrumb': '#54938B',
    'left-nav-text-color': '#B3B5CB',
    'left-nav-active-text-color': 'white',
    'color-left-nav-background': '#43467F',
    'time-line': '#47C1BF',
    'toast-background-shadow': '#B7ECEC',

    'icomoon-color': '#47C1BF',
    'sidebar-tenant-color': 'white',
    'closed-overview-color': '#c4cdd5',
    'backGroundColors': '#41457c',
    'recentActivityPanColor': '#00044C',
    'HOtitle': '#00044C',
    'textAreaOnFocusBroderHighLight': '#36B5AC',
    'tableListHoverColor': 'transparentize(#7DB4AC, .9)',

    'toastSuccessColor':'#154246',
    'toastSuccessBackGroundColor':'#E0F5F5',
    'toastSuccessBorderColor':'#154246',
    'toastSuccessProgressBarColor':'#154246',
    'toastSuccessCloseButtonColor':'#154246',


    'toastErrorColor':'#5A302F',
    'toastErrorBackGroundColor':'hsl(14, 72%, 94%)',
    'toastErrorBorderColor':'#5A302F',
    'toastErrorProgressBarColor':'#5A302F',
    'toastErrorCloseButtonColor':"#5A302F",
    'color-expires-text': "#573B00",

    'primary-heading-font': "DM Serif Display,serif",
    'general-content-font': 'Assistant,sans-serif',
    'secondary-heading-font': "Assistant,sans-serif",
}

const StrandColors = {
    'color-ink-lightest': '#8C9093',
    'color-complete-button': '#6C6E70',
    'color-teal-dark': '#000000',
    'button-background-color': '#000000',
    'color-juniper': '#6C6E70',
    'toast-message-text': '#6C6E70',
    'color-search-border': "#6C6E70",
    'complete-button': '#6C6E70',
    'color-ink-lighter': '#A1A1A1',
    'color-disabled-button': "#A1A1A1",
    'color-sky': '#DFE3E8',
    'color-teal': '#313131',
    'color-checkIcon': '#313131',
    'walkthroughcompletecheckbox': '#313131',
    'color-sidebar-button-text': 'white',
    'color-issue-type-header': '#6C6E70',
    'color-anchor-link': '#6C6E70',

    'color-ink-light': '#A1A1A1',
    'color-juniper-dark': '#3C4245',
    'tab-background-color': '#3C4245',
    'color-juniper-darker': '#1D1D1D',
    'color-red-darker': '#211A1A',
    'color-red-lighter': '#BFBFBF',
    'color-sky-dark': '#BFBFBF',
    'color-teal-darker': '#8C9093',
    'color-teal-lighter': '#F5F5F5',
    'color-yellow-lighter': '#C0C0C0',
    'color-yellow-darker': '#272727',
    'links': '#272727',
    'color-dark': '#272727',
    'breadcrumb': '#272727',
    'left-nav-text-color': '#AEAEAE',
    'left-nav-active-text-color': 'white',
    'color-left-nav-background': '#6C6E70',

    'time-line': '#C0C0C0',
    'toast-background-shadow': '#AEAEAE',

    'icomoon-color': '#545454',
    'sidebar-tenant-color': 'white',
    'closed-overview-color': '#BBBBBB',
    'backGroundColors': '#414141',
    'recentActivityPanColor': '#1D1D1D',
    'HOtitle': '#342C2C',
    'textAreaOnFocusBroderHighLight': '#464646',
    'tableListHoverColor': 'transparentize(#464646, .9)',

    'toastSuccessColor':'#FFFFFF',
    'toastSuccessBackGroundColor':'#1D1D1D',
    'toastSuccessBorderColor':'#000000',
    'toastSuccessProgressBarColor':'#dfe6df',
    'toastSuccessCloseButtonColor':'#dfe6df',


    'toastErrorColor':'#900501',
    'toastErrorBackGroundColor':'hsl(2, 56%, 81%)',
    'toastErrorBorderColor':'#900501',
    'toastErrorProgressBarColor':'#900501',
    'toastErrorCloseButtonColor':"#900501",
    'color-expires-text': "#573B00",

    'primary-heading-font': "Gotham Narrow",
    'general-content-font': "Open Sans, sans-serif",
    'secondary-heading-font': "Open Sans, sans-serif",
}

const FormwerksColors = {
    'color-ink-lightest': '#919EAB',
    'color-complete-button': '#002D56',
    'color-teal-dark': '#002D56',
    'button-background-color': '#002D56',
    'color-juniper': '#fff',
    'toast-message-text': '#002D56',
    'color-search-border': "#fff",
    'complete-button': '#fff',
    'color-issue-type-header': '#002D56',
    'color-ink-lighter': '#637381',
    'color-disabled-button': "#637381",
    'color-sky': '#DFE3E8',
    'color-teal': '#002D56',
    'color-checkIcon': '#002D56',
    'walkthroughcompletecheckbox': '#fff',
    'color-sidebar-button-text': '#002D56',
    'color-anchor-link': '#002D56',

    'color-ink-light': '#002D56',
    'color-juniper-dark': '#002D56',
    'tab-background-color': '#002D56',

    'color-juniper-darker': '#002D56',
    'color-red-darker': '#330001',
    'color-red-lighter': '#FBE9E5',
    'color-sky-dark': '#C4CDD5',
    'color-teal-darker': '#002D56',
    'color-teal-lighter': '#E0F5F5',
    'color-yellow-lighter': '#002D56',
    'color-yellow-darker': '#fff',
    'links': '#002D56',
    'color-dark': '#212B36',
    'breadcrumb': '#002D56',
    'left-nav-text-color': '#fff',

    'left-nav-active-text-color': '#002D56',
    'color-left-nav-background': '#fff',

    'time-line': '#002D56',
    'toast-background-shadow': '#002D56',


    'icomoon-color': '#002D56',
    'sidebar-tenant-color': '#fff',
    'closed-overview-color': '#002D56',
    'backGroundColors': '#002D56',
    'recentActivityPanColor': '#002D56',
    'HOtitle': '#002D56',
    'textAreaOnFocusBroderHighLight': '#002D56',
    'tableListHoverColor': 'transparentize(#002D56, .9)',


    'toastSuccessColor':'#fff',
    'toastSuccessBackGroundColor':'#002D56',
    'toastSuccessBorderColor':'#002D56',
    'toastSuccessProgressBarColor':'#002D56',
    'toastSuccessCloseButtonColor':'#fff',
    'toastErrorColor':'#5A302F',
    'toastErrorBackGroundColor':'hsl(14, 72%, 94%)',
    'toastErrorBorderColor':'#5A302F',
    'toastErrorProgressBarColor':'#5A302F',
    'toastErrorCloseButtonColor':"#5A302F",
    'color-expires-text': "#573B00",

    'primary-heading-font': "HelveticaNeue-Thin",
    'general-content-font': 'HelveticaNeue-Light',
    'secondary-heading-font': "HelveticaNeue-Light"
}

const ShapeColors = {
    'color-ink-lightest': '#000000',
    'color-complete-button': '#666666',
    'color-teal-dark': '#000000',
    'button-background-color': '#000000',
    'color-juniper': '#666666',
    'toast-message-text': '#666666',
    'color-search-border': "#666666",
    'complete-button': '#666666',
    'color-issue-type-header': '#000000',
    'color-ink-lighter': '#2B2E34',
    'color-disabled-button': "#2B2E34",
    'color-sky': '#DFE3E8',
    'color-teal': '#000000',
    'color-checkIcon': '#666666',
    'walkthroughcompletecheckbox': '#666666',
    'color-sidebar-button-text': '#000000',
    'color-anchor-link': '#000000',

    'color-ink-light': '#000000',
    'color-juniper-dark': '#000000',
    'tab-background-color': '#000000',

    'color-juniper-darker': '#000000',
    'color-red-darker': '#330001',
    'color-red-lighter': '#FBE9E5',
    'color-sky-dark': '#C4CDD5',
    'color-teal-darker': '#000000',
    'color-teal-lighter': '#E0F5F5',
    'color-yellow-lighter': '#000000',
    'color-yellow-darker': '#F9F9F9',
    'links': '#000000',
    'color-dark': '#212B36',
    'breadcrumb': '#000000',
    'left-nav-text-color': '#fff',

    'left-nav-active-text-color': '#fff',
    'color-left-nav-background': '#666666',

    'time-line': '#000000',
    'toast-background-shadow': '#000000',


    'icomoon-color': '#000000',
    'sidebar-tenant-color': '#fff',
    'closed-overview-color': '#000000',
    'backGroundColors': '#000000',
    'recentActivityPanColor': '#000000',
    'HOtitle': '#000000',
    'textAreaOnFocusBroderHighLight': '#000000',
    'tableListHoverColor': 'transparentize(#000000, .9)',


    'toastSuccessColor':'#fff',
    'toastSuccessBackGroundColor':'#000000',
    'toastSuccessBorderColor':'#000000',
    'toastSuccessProgressBarColor':'#000000',
    'toastSuccessCloseButtonColor':'#fff',
    'toastErrorColor':'#5A302F',
    'toastErrorBackGroundColor':'hsl(14, 72%, 94%)',
    'toastErrorBorderColor':'#5A302F',
    'toastErrorProgressBarColor':'#5A302F',
    'toastErrorCloseButtonColor':"#5A302F",
    'color-expires-text': "#573B00",

    'primary-heading-font': "ProximaNovaThin",
    'general-content-font': 'ProximaNovaBold',
    'secondary-heading-font': "ProximaNovaBold"
}


const QuadraColors = {
    'color-ink-lightest': '#8C9093',
    'color-complete-button': '#6C6E70',
    'color-teal-dark': '#000000',
    'button-background-color': '#000000',
    'color-juniper': '#6C6E70',
    'toast-message-text': '#6C6E70',
    'color-search-border': "#6C6E70",
    'complete-button': '#6C6E70',
    'color-ink-lighter': '#A1A1A1',
    'color-disabled-button': "#A1A1A1",
    'color-sky': '#DFE3E8',
    'color-teal': '#313131',
    'color-checkIcon': '#313131',
    'walkthroughcompletecheckbox': '#DFE3E8',
    'color-sidebar-button-text': 'white',
    'color-issue-type-header': '#6C6E70',
    'color-anchor-link': '#6C6E70',

    'color-ink-light': '#A1A1A1',
    'color-juniper-dark': '#3C4245',
    'tab-background-color': '#3C4245',
    'color-juniper-darker': '#1D1D1D',
    'color-red-darker': '#211A1A',
    'color-red-lighter': '#BFBFBF',
    'color-sky-dark': '#BFBFBF',
    'color-teal-darker': '#8C9093',
    'color-teal-lighter': '#F5F5F5',
    'color-yellow-lighter': '#C0C0C0',
    'color-yellow-darker': '#272727',
    'links': '#272727',
    'color-dark': '#272727',
    'breadcrumb': '#272727',
    'left-nav-text-color': '#AEAEAE',
    'left-nav-active-text-color': 'white',
    'color-left-nav-background': '#6C6E70',

    'time-line': '#C0C0C0',
    'toast-background-shadow': '#AEAEAE',

    'icomoon-color': '#545454',
    'sidebar-tenant-color': 'white',
    'closed-overview-color': '#BBBBBB',
    'backGroundColors': '#414141',
    'recentActivityPanColor': '#1D1D1D',
    'HOtitle': '#342C2C',
    'textAreaOnFocusBroderHighLight': '#464646',
    'tableListHoverColor': 'transparentize(#464646, .9)',

    'toastSuccessColor':'#FFFFFF',
    'toastSuccessBackGroundColor':'#1D1D1D',
    'toastSuccessBorderColor':'#000000',
    'toastSuccessProgressBarColor':'#dfe6df',
    'toastSuccessCloseButtonColor':'#dfe6df',


    'toastErrorColor':'#900501',
    'toastErrorBackGroundColor':'hsl(2, 56%, 81%)',
    'toastErrorBorderColor':'#900501',
    'toastErrorProgressBarColor':'#900501',
    'toastErrorCloseButtonColor':"#900501",
    'color-expires-text': "#573B00",

    'primary-heading-font': 'MyriadProBold',
    'general-content-font': 'MinionProRegular',
    'secondary-heading-font': "MinionProRegular"
};

const PanatchColors = {
    'color-ink-lightest': '#000000',
    'color-complete-button': '#1D295D',
    'color-teal-dark': '#1D295D',
    'button-background-color': '#1D295D',
    'color-juniper': '#1D295D',
    'toast-message-text': '#1D295D',
    'color-search-border': "#909191",
    'complete-button': '#ffffff',

    'color-ink-lighter': '#000000',
    'color-disabled-button': "#909191",
    'color-sky': '#DFE3E8',
    'color-teal': '#1D295D',
    'color-checkIcon': '#1D295D',
    'walkthroughcompletecheckbox': '#fff',
    'color-sidebar-button-text': '#ffffff',
    'color-issue-type-header': '#1D295D',
    'color-anchor-link': '#1D295D',
    'color-ink-light': '#000000',
    'color-juniper-dark': '#1D295D',
    'tab-background-color': '#1D295D',

    'color-juniper-darker': '#1D295D',
    'color-red-darker': '#330001',
    'color-red-lighter': '#FBE9E5',
    'color-sky-dark': '#C4CDD5',
    'color-teal-darker': '#1D295D',
    'color-teal-lighter': '#E0F5F5',
    'color-yellow-lighter': '#1D295D',
    'color-yellow-darker': '#ffffff',
    'links': '#1D295D',
    'color-dark': '#000000',
    'breadcrumb': '#1D295D',
    'left-nav-text-color': '#ffffff',
    'left-nav-active-text-color': '#1D295D',
    'color-left-nav-background': '#ffffff',

    'time-line': '#1D295D',
    'toast-background-shadow': '#1D295D',


    'icomoon-color': '#1D295D',
    'sidebar-tenant-color': '#fff',
    'closed-overview-color': '#1D295D',
    'backGroundColors': '#1D295D',
    'recentActivityPanColor': '#1D295D',
    'HOtitle': '#1D295D',
    'textAreaOnFocusBroderHighLight': '#1D295D',
    'tableListHoverColor': 'transparentize(#1D295D, .9)',


    'toastSuccessColor':'#ffffff',
    'toastSuccessBackGroundColor':'#1D295D',
    'toastSuccessBorderColor':'#1D295D',
    'toastSuccessProgressBarColor':'#1D295D',
    'toastSuccessCloseButtonColor':'#ffffff',
    'toastErrorColor':'#5A302F',
    'toastErrorBackGroundColor':'hsl(14, 72%, 94%)',
    'toastErrorBorderColor':'#5A302F',
    'toastErrorProgressBarColor':'#5A302F',
    'toastErrorCloseButtonColor':"#5A302F",
    'color-expires-text': "#ffffff",

    'primary-heading-font': "MrEavesXLModOT-Bold",
    'general-content-font': 'MrEavesXLModOT-Reg',
    'secondary-heading-font': "MrEavesXLModOT-Reg"
};

const GateHouseColors = {
    'color-ink-lightest': '#919EAB',
    'color-complete-button': '#386BB3',
    'color-teal-dark': '#887D79',
    'button-background-color': '#386BB3',
    'color-juniper': '#000000',
    'toast-message-text': '#887D79',
    'color-search-border': "#fff",
    'complete-button': '#fff',
    'color-ink-lighter': '#637381',
    'color-disabled-button': "#637381",
    'color-sky': '#DFE3E8',
    'color-teal': '#386BB3',
    'color-checkIcon': '#887D79',
    'walkthroughcompletecheckbox': '#fff',
    'color-sidebar-button-text': 'white',
    'color-issue-type-header': '#887D79',
    'color-anchor-link': '#887D79',

    'color-ink-light': '#454F5B',
    'color-juniper-dark': '#887D79',
    'tab-background-color': '#386BB3',

    'color-juniper-darker': '#000000',
    'color-red-darker': '#330001',
    'color-red-lighter': '#FBE9E5',
    'color-sky-dark': '#C4CDD5',
    'color-teal-darker': '#003135',
    'color-teal-lighter': '#E0F5F5',
    'color-yellow-lighter': '#FBF1CD',
    'color-yellow-darker': '#573A00',
    'links': '#000000',
    'color-dark': '#212B36',
    'breadcrumb': '#887D79',
    'left-nav-text-color': '#fff',
    'left-nav-active-text-color': '#887D79',
    'color-left-nav-background': '#fff',
    'time-line': '#887D79',
    'toast-background-shadow': '#B7ECEC',

    'icomoon-color': '#887D79',
    'sidebar-tenant-color': 'white',
    'closed-overview-color': '#c4cdd5',
    'backGroundColors': '#887D79',
    'recentActivityPanColor': '#887D79',
    'HOtitle': '#887D79',
    'textAreaOnFocusBroderHighLight': '#887D79',
    'tableListHoverColor': 'transparentize(#7DB4AC, .9)',

    'toastSuccessColor':'#fff',
    'toastSuccessBackGroundColor':'#386BB3',
    'toastSuccessBorderColor':'#fff',
    'toastSuccessProgressBarColor':'#fff',
    'toastSuccessCloseButtonColor':'#fff',


    'toastErrorColor':'#5A302F',
    'toastErrorBackGroundColor':'hsl(14, 72%, 94%)',
    'toastErrorBorderColor':'#5A302F',
    'toastErrorProgressBarColor':'#5A302F',
    'toastErrorCloseButtonColor':"#5A302F",
    'color-expires-text': "#573B00",

    'primary-heading-font': "SangBleu Kingdom",
    'general-content-font': 'Assistant,sans-serif',
    'secondary-heading-font': "Sequel Sans Medium Body",
}

const FormwerksThemeColor = "#002d56";
export 
   { RizeColors, AlbasterColors, JuniperColors, StrandColors, FormwerksColors, ShapeColors, QuadraColors, PanatchColors, FormwerksThemeColor,
    GateHouseColors 
   };